import * as React from "react";
import { penaltyRequest } from "./api.js";
import { IconCoin, IconDiamond, IconCards, IconSparkles } from "../../components/icons.jsx";

const labels = { metacoin: "MetaCoin", crystal: "Кристаллы", spin: "Крутки", gems: "Рубины", event: "Тыквы" };
const outcomes = { lost: "Сейв", cashed_out: "Выигрыш", maxed: "Автовыплата" };
const icons = { metacoin: IconCoin, crystal: IconDiamond, spin: IconCards, gems: IconSparkles, event: () => <span aria-hidden="true">🎃</span> };
const fmt = value => Number(value || 0).toLocaleString("ru-RU");
const mult = value => `×${(value / 100).toLocaleString("ru-RU", { maximumFractionDigits: 2 })}`;

export function PenaltyHistory({ initData, personalHistory }) {
  const [scope, setScope] = React.useState("all");
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [refresh, setRefresh] = React.useState(0);

  React.useEffect(() => {
    if (scope !== "all") return;
    let cancelled = false;
    setLoading(true); setError("");
    penaltyRequest("feed", {}, initData).then(result => {
      if (!cancelled) setItems(result.items);
    }).catch(failure => {
      if (!cancelled) setError(failure.message || "Не удалось загрузить общую ленту");
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [scope, initData, refresh]);

  const rounds = (scope === "all" ? items : personalHistory).filter(item =>
    (item.status === "cashed_out" || item.status === "maxed") && item.payout > 0);
  return (
    <div className="penalty-history">
      <div className="penalty-history-switch" role="group" aria-label="История игр">
        <button type="button" aria-pressed={scope === "all"} onClick={() => setScope("all")}>Все игры</button>
        <button type="button" aria-pressed={scope === "mine"} onClick={() => setScope("mine")}>Мои игры</button>
      </div>
      <div className="penalty-history-heading">
        <h2>{scope === "all" ? "Выигрыши игроков" : "Ваши выигрыши"}</h2>
        {scope === "all" && <button type="button" disabled={loading} onClick={() => setRefresh(value => value + 1)} aria-label="Обновить общую ленту">Обновить</button>}
      </div>
      {scope === "all" && loading && <p role="status">Загружаем игры…</p>}
      {scope === "all" && error && <p className="penalty-history-error" role="alert">{error}</p>}
      {!rounds.length && (scope === "mine" || (!loading && !error)) && <p>В последних раундах выигрышей пока нет.</p>}
      {rounds.map(item => {
        const Icon = icons[item.currency];
        const name = scope === "mine" ? "Вы" : item.playerName || "Игрок";
        return <article key={item.id} className={`penalty-history-card ${scope === "mine" || item.isMe ? "penalty-history-own" : ""}`}>
          <div className="penalty-history-meta">
            <span title={`Раунд ${item.id}`}>Игра #{item.id.slice(0, 8)}</span>
            <time dateTime={item.finished_at} title={new Date(item.finished_at).toLocaleString("ru-RU")}>{new Date(item.finished_at).toLocaleString("ru-RU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</time>
          </div>
          <div className="penalty-history-identity">
            <span className="penalty-history-avatar" aria-hidden="true">{Array.from(name.trim())[0]?.toUpperCase() || "И"}</span>
            <span className="penalty-history-player" title={name}><span>{name}</span>{scope === "all" && item.isMe && <small>Вы</small>}</span>
            <span className="penalty-history-stake" aria-label={`Ставка ${fmt(item.stake)} ${labels[item.currency]}`} title={labels[item.currency]}><Icon aria-hidden="true" />{fmt(item.stake)}</span>
          </div>
          <dl className="penalty-history-stats">
            <div><dt>Голы</dt><dd>{item.goals}</dd></div>
            <div><dt>Множитель</dt><dd>{mult(item.multiplier)}</dd></div>
            <div className={item.payout ? "penalty-history-win" : "penalty-history-loss"}><dt>{outcomes[item.status]}</dt><dd aria-label={`Выплата ${fmt(item.payout)} ${labels[item.currency]}`} title={labels[item.currency]}><Icon aria-hidden="true" />{fmt(item.payout)}</dd></div>
          </dl>
        </article>;
      })}
    </div>
  );
}
